import { render, staticRenderFns } from "./AdjustPriceDialog.vue?vue&type=template&id=61347fd0"
import script from "./AdjustPriceDialog.vue?vue&type=script&lang=js"
export * from "./AdjustPriceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports